import { I18n } from '@calendly/i18n'
import { MailSendEnvelopeIcon, CalendarAddIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { colorTextAction } from '@calendly/ui/theme'

import { useFFTrackingV2 } from 'hooks/analytics_events/use_ff_tracking_v2'

import { CardButton } from './elements/card_button'
import { PopupBody } from './elements/popup_body'
import { Header } from './elements/popup_header'
import { RescheduleFlowModal } from './reschedule_flow_modal'


export const SelectRescheduleMethodPopup = ({
  eventType,
  invitee,
  isInviteeOnlyReschedule,
  isOpen,
  onClose,
  onReschedule,
  onShare
}) => {
  useFFTrackingV2('host_reschedule_invitee_experience')

  return (
    <RescheduleFlowModal
      isOpen={isOpen}
      onClose={onClose}
      withCloseButton
      ariaLabel={isInviteeOnlyReschedule
        ? I18n.t('publisher.rescheduling_flow.title_invitee')
        : I18n.t('publisher.rescheduling_flow.title')}
    >
      <Header
        invitee={invitee}
        eventType={eventType}
        isInviteeOnlyReschedule={isInviteeOnlyReschedule}
      />
      <PopupBody>
        <BodyText weight="bold">
          {isInviteeOnlyReschedule
            ? I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.subtitle_invitee')
            : I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.subtitle')}
        </BodyText>
        <CardButton
          icon={<MailSendEnvelopeIcon size="x-large" color={colorTextAction} />}
          header={I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.share_card.title')}
          body={isInviteeOnlyReschedule
            ? I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.share_card.body_invitee', { invitee_name: invitee.name })
            : I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.share_card.body')}
          onClick={onShare}
        />
        <CardButton
          icon={<CalendarAddIcon size="x-large" color={colorTextAction} />}
          header={isInviteeOnlyReschedule
            ? I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.book_card.title_invitee', { invitee_name: invitee.name })
            : I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.book_card.title')}
          body={isInviteeOnlyReschedule
            ? I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.book_card.body_invitee', { invitee_name: invitee.name })
            : I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.book_card.body')}
          onClick={onReschedule}
        />
      </PopupBody>
    </RescheduleFlowModal>
  )
}
